import React from 'react';
import {compose} from "redux";
import {withRouter} from "react-router";

import styles from './ExitModal.module.scss';
import {appendBasePath} from "../../../utils/nav.utils";

const ExitModal = ({ onClose, url, description = "Your information will not be saved.", local = false, history }) => {
  return (
    <div>
      <div className={styles.title}>Are you sure you want to leave?</div>
      <div className={styles.description}>
        {description}
      </div>
      <div className={styles['button-container']}>
        <button onClick={onClose} className={styles.stay}>
          Stay on This Page
        </button>
        { local ?
          <button
            id="exit-modal-to-dashboard-btn"
            className={styles.leave}
            onClick={(e) => {
              onClose();
              history.push(appendBasePath("/"))
            }}
          >
            Leave This Page
          </button>
          :
          <a id="exit-modal-leave-btn" className={styles['no-underline']} href={url}>
            <div className={styles.leaveLink}>Leave This Page</div>
          </a>
        }
      </div>
    </div>
  );
};

export default compose(withRouter)(ExitModal);
